export function buildApiUrl(apiUrlPrefix, endpoint) {
  return process.env.VUE_APP_BASE_URL + apiUrlPrefix + endpoint
}

export function axiosSetDefaultHeaders(axios, processEnv) {
  axios.defaults.baseURL = process.env.VUE_APP_API_URL

  axios.defaults.headers.common['Accept'] = 'application/json'
  axios.defaults.headers.common['Content-Type'] = 'application/json'
}

export function axiosInterceptorsAuthHeadersUse(store, axios) {
  axios.interceptors.response.use(null, async error => {

    if (!error.response || error.response.status !== 401) {
      return Promise.reject(error);
    }

    const request = error.config;
    if (request.data) {
      let data = JSON.parse(request.data);
      if (data && data.grant_type) {
        console.log('grant type reject error')
        return Promise.reject(error)
      }
    }
    console.log('before dispatch refresh')
    const response = store.dispatch('refresh')
      .then(() => {
        return new Promise((resolve) => {
          request.headers['Authorization'] = 'Bearer ' + store.state.user.access_token
          //request.baseURL = ''; //probably issue of AXIOS - url contains baseUrl but Axios adding baseUrl to the URL
          resolve(axios(request))
        })
      })
      .catch((updatedCredsResponseError) => {
        //Added validation status because API can return 404 error and trigger this catch
        console.log(updatedCredsResponseError)
        if (!updatedCredsResponseError.response || updatedCredsResponseError.response.status === 401) {
          if (process.env.VUE_APP_ENV !== 'production') {
            console.log('redirect to login page')
            //router.push({name: 'login'})
          } else {
            window.location.href = process.env.VUE_APP_LOGOUT_URL;
          }
          //router.push({name: 'login'});
          return Promise.reject(error)
        }
      })
    return response
  })
}
